@if(loading){

}
@else {
<mat-sidenav-container class="trans-overlay" id="main-drawer-container" >
	<mat-sidenav #appSidenav mode="over" position="start" class="app-sidenav">
		<app-sidenav (onSideNvaAction)="onSideNvaAction($event)" [sideNav]="appSidenav" workMode="tabitPay"></app-sidenav>
	</mat-sidenav>
	@if (step === stepsMap.enter){
	<app-tabitpay-enter-order [options]="childOptions" (enterOrder)="lookUpOrder($event)" (loadOrder)="loadOrder($event)"></app-tabitpay-enter-order>
	} @else if (step >= stepsMap.ticket) {
	<div class="module-container" [class.with-banner]="appService.showAppBanner">
		<div class="module-bar-fixed">
			@if (step > stepsMap.ticket) {
			<button mat-icon-button color="accent" (mousedown)="goBack()">
				<mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
			</button>
			}
			<span class="title text-truncate" [class.ml-2]="step == stepsMap.ticket">
				<div>{{siteName}}</div>
				@if ($storage.order.tableNO) {
					<small style="position:relative;" [innerHTML]="'OAT.table_no_alt' | translate: {v: $storage.order.tableNO} | safeHtml"></small>
				}
			</span>

			@if (step >= stepsMap.ticket) {
				<button mat-icon-button (mousedown)="dialogsService.passOrder()">
					<mat-icon svgIcon="paper_plane" class="rotate-rtl"></mat-icon>
				</button>
			}
			@if (appService.regionArgs.translations) {
				<button mat-icon-button (mousedown)="toggleTranslation()">
					<mat-icon svgIcon="globe"></mat-icon>
				</button>
			}
			@if (step === stepsMap.ticket && appService.regionArgs.enableLogin) {
				@if (appService.user) {
					<button mat-mini-fab color="accent" (mousedown)="toggleAppSidenav()" style="box-shadow:none">
						{{ appService.user.initials }}
					</button>
				} @else {
					<button mat-icon-button color="accent" (mousedown)="toggleAppSidenav()">
						<mat-icon svgIcon="bars"></mat-icon>
					</button>
				}
			}
		</div>

		<div class="module-body">
			<!--AMOUNT STEP-->
			@if ($storage.order) {
				@switch (step) {
					@case (stepsMap.ticket) {
						@if ($storage?.order?.isTabOrder) {
							<app-tabitpay-tab [options]="childOptions" (onContinue)="gotoPaymentClick($event)" (onCheckSelect)="onCheckSelect($event)"></app-tabitpay-tab>
						} @else {
							<app-tabitpay-ticket [options]="childOptions" (onContinue)="gotoPaymentClick($event)" (onCheckSelect)="onCheckSelect($event)"></app-tabitpay-ticket>
						}
					}
					@case (stepsMap.partial) {
						<app-tabitpay-checkout-partial [options]="childOptions" (onContinue)="goFroward($event)" (onPayment)="onPayment($event)"></app-tabitpay-checkout-partial>
					}
					@case (stepsMap.pay) {
						<app-tabitpay-checkout-pay [options]="childOptions" (onPayment)="onPayment($event)"></app-tabitpay-checkout-pay>
					}
				}
			}
		</div>
	</div>
	}
</mat-sidenav-container>
}
